<template>
  <v-img
    :src="backgroundImg"
  >
    <v-container fluid class="mx-0 mb-0 pa-0 mt-5">
      <v-layout row wrap text-xs-center>
        <v-flex xs12 class="mt-5">
          <div class="display-2 black--text" v-text="banner.title"></div>
          <div class="display-1 black--text" v-text="banner.subtitle"></div>
        </v-flex>
        <v-flex xs12>
          <v-container grid-list-lg>
            <v-layout row wrap justify-center class="text-xs-center" mt-5>
              <v-flex xs12 sm12 md4 lg3
                class="mx-3 mb-5 price-card"
                v-for="(plan, i) in plans"
                :key="i"
              >
                <v-card class="py-4"
                  :class="[plan.name === choosed.name ? 'elevation-20' : '']"
                  :color="plan.name === choosed.name ? 'orange' : 'gray'"
                  :dark="plan.name !== choosed.name"
                >
                  <v-card-text class="no-mrpd">
                    <h4 class="display-1">{{ plan.name }}</h4>
                    <p class="subheading">{{ plan.audience }}</p>
                    <div class="cost box-red-300-glow white--text" v-html="plan.cost"></div>
                    <p v-for="(feature, i) in plan.features" :key="i" v-html="feature" class="body-2"></p>
                  </v-card-text>
                  <v-btn color="box-deep-purple-a700-glow" @click="setPlan(plan)" dark>{{ plan.action.text }}</v-btn>
                  <p v-html="plan.trial"></p>
                </v-card>
              </v-flex>
            </v-layout>
          </v-container>
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-flex xs12>
          <v-container grid-list-lg>
            <v-layout row wrap>
              <v-flex xs12 text-xs-center>
                <h4 class="display-1 black--text">FAQ</h4>
                <p class="title black--text">It's okay. We all have questions that need answers.</p>
              </v-flex>
              <v-flex xs12 sm6
                v-for="(faq, i) in faqs"
                :key="i"

              >
                <v-card class="pa-4">
                  <v-card-title primary-title>
                    <div class="title">
                      <v-icon left>{{ faq.icon }}</v-icon> {{ faq.title }}
                    </div>
                    <div v-html="faq.detail"></div>
                  </v-card-title>
                </v-card>
              </v-flex>
            </v-layout>
          </v-container>
        </v-flex>
      </v-layout>
    </v-container>
  </v-img>
</template>

<script>
import { rgba as Gradients } from "@/data/gradients";
import ToolbarSimple from "@/layouts/FullPageSimple/Toolbar";
export default {
  beforeCreate() {
    window.scrollTo(0, 0);
  },
  // mounted() {
  //   // Google Analytics
  //   this.$ga.page(this.$router);
  // },
  data() {
    return {
      gradient: Gradients[9],
      backgroundImg: "",
      banner: {
        title: `Get Started Today`,
        subtitle: `Free 5 days trial`,
        description: "Joining takes less than a minute."
      },
      plans: [
        {
          name: "Basic",
          audience: "Prepaid plan",
          cost: `<span class="display-1"><sup>$</sup> 10</span> per 20 documents`,
          features: [
            "Electronic signature",
            "Certified delivery",
            "Notifications & reminders",

            "Email Support"
          ],
          action: {
            text: "Get started"
          },
          trial: `<div class="cyan--text">7 day free trial to start</div>`
        },
        {
          name: "Standard",
          audience: "For small business",
          cost: `<span class="display-1"><sup>$</sup> 5.5</span> monthly per user`,
          features: [
            "Electronic signature",
            "Video identifications",
            "Certified delivery",
            "Up to 20 documents per month",
            "Notifications & reminders",

            "Email Support"
          ],
          action: {
            text: "Get started"
          },
          trial: `<div class="black--text"> credit for new A/C</div>`
        },
        {
          name: "Premium",
          audience: "For unlimited users",
          cost: `<span class="display-1"><sup>$</sup> 20</span> monthly per user`,
          features: [
            "Electronic signature",
            "Video identifications",
            "Certified delivery",
            "Up to 100 documents per month",
            "Notifications & reminders",

            "Email Support"
          ],
          action: {
            text: "Get started"
          },
          trial: `<div class="cyan--text">Backup + Cloud storage</div>`
        }
      ],
      faqs: [
        {
          title: "Can I cancel at any time?",
          icon: "message",
          detail: `Securyty subscriptions renew, just like Netflix or Hulu. But, of course you can cancel at any point. Visit your settings page, click "Cancel," and done.`
        },
        {
          title: "Do the signatories have to pay?",
          icon: "message",
          detail: `No, only the people who send documents to be signed need to have a Securyty subscription. Those people receiving signature's requests will only have to open the email and start signing`
        },
        {
          title: "What is a user?",
          icon: "message",
          detail: `Users are people sending documents to be signed from Signaturit. They have their own login, password, preferences and settings configured in their Signaturit account.`
        },
        {
          title: "Seriously, was Total Recall a dream or not?",
          icon: "message",
          detail: `Vuse subscriptions renew, just like Netflix or Hulu. But, of course you can cancel at any point. It would be a pretty shabby business, if that wasn't an option. :) Seriously — it's not like the gym. Visit your settings page, click "Cancel," and done. Tears will be shed on this end, but that's not your concern.`
        }
      ],
      choosed: {
        name: "Standard",
        audience: "For 10 users",
        cost: `<span class="display-1"><sup>$</sup> 12.5</span> monthly per user`,
        features: [
          "2 xxvCPU",
          "2TB Transfer",
          "30GB SSD Disk",
          "30 Projects",
          "60 Boards",
          "24/7 Support"
        ],
        action: {
          text: "Get started"
        },
        trial: `<div class="pink--text">$5 credit for new A/C</div>`
      }
    };
  },
  components: {
    ToolbarSimple
  },
  methods: {
    setPlan(plan) {
      if (plan.audience === 'Prepaid plan') {
        this.$ga.event({
          eventCategory: "PrepaidPlan", // str
          eventAction: "click", // str
          eventLabel: "GetStartedButton", // str
          eventValue: 0 // int
        });
      } else if (plan.audience === 'For small business') {
        this.$ga.event({
          eventCategory: "ForSmallBusiness", // str
          eventAction: "click", // str
          eventLabel: "GetStartedButton", // str
          eventValue: 0 // int
        });
      } else if (plan.audience === 'For unlimited users') {
        this.$ga.event({
          eventCategory: "ForUnlimitedUsers", // str
          eventAction: "click", // str
          eventLabel: "GetStartedButton", // str
          eventValue: 0 // int
        });
      }
      this.choosed = plan;
    }
  }
};
</script>

<style scoped lang="stylus">
  .price-scheme
    margin-top: -140px
  .elevate
    margin-top: -74px
  .cost
    padding: 10px 0
    margin-bottom: 20px
  .price-card
    max-width 320px
</style>
